import React from 'react'
import Header from './Header'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

const GuestLayout: React.FC<{ logo: string; isLoading: boolean; showPoweredByLogo: boolean; headerBG: string }> = ({
  logo,
  isLoading,
  showPoweredByLogo,
  children,
  headerBG
}) => {
  const theme = useTheme()
  return (
    <>
      <Header logo={logo} isLoading={isLoading} headerBG={headerBG} />
      <Box
        sx={{
          width: '100%',
          marginBottom: 2,
          overflow: 'auto',
          height: {
            xs: 'calc(100% - 56px)',
            sm: 'calc(100% - 64px)'
          }
        }}
      >
        {children}
      </Box>
      {/* {showPoweredByLogo && (
        <Grid
          item
          xs={6}
          sx={{
            textAlign: 'left',
            flex: 1,
            width: '10%',
            position: 'inherit',
            float: 'left',
            zIndex: 12
          }}
        >
          <img width={100} src={'/images/poweredByRakonto.png'} alt="rakonto" />
        </Grid>
      )} */}
    </>
  )
}

export default GuestLayout
